import { Modal } from '@sb1/ffe-modals-react';
import { useProject } from '../../project-hooks/useProject';
import { useState } from 'react';
import { IMAGE, QR, INSTAGRAM, TVA_IMAGES } from './share-on-project-model';
import { ImageModalContainer } from './ImageModalContainer';
import { MobileStartModalContainer } from './MobileStartModalContainer';
import InstagramShareInstructionsModalBlock from '../share-instructions-modal/InstagramShareInstructionsModalBlock';
import { isMobile } from '../../../utils';
import { useSelector } from 'react-redux';
import TvaImagesModalContent from '../TvaImagesModalContent';
import { getUserAgent } from '../../../utils/browserDetector';

export const MobileShareOnProjectModal = ({ modalRef, prettyUrlToShare, trackingProperties, subprojectId }) => {
    const [showPage, setShowPage] = useState(null);
    const project = useProject();
    const userAgent = useSelector((state) => getUserAgent(state));

    const imageBaseUrl = `/api/public/project/${project.id}`;

    if (!isMobile(userAgent)) {
        return null;
    }

    const renderContent = () => {
        if (showPage === IMAGE) {
            return (
                <ImageModalContainer
                    onBack={() => setShowPage(null)}
                    heading={'Delingsbilde'}
                    subHeading={'Del bildet i sosiale medier for å vise din støtte til spleisen.'}
                    url={`${imageBaseUrl}/shareImage${subprojectId ? `?subprojectId=${subprojectId}` : ''}`}
                    type={'image'}
                    downloadText={'Last ned bildet'}
                    trackingProperties={trackingProperties}
                />
            );
        } else if (showPage === QR) {
            return (
                <ImageModalContainer
                    onBack={() => setShowPage(null)}
                    heading={'QR-kode'}
                    imageBorder={true}
                    subHeading={
                        'Skriv ut QR-koden og vis den frem til potensielle givere slik at det blir enklere for dem å gi.'
                    }
                    url={`${imageBaseUrl}/qr${subprojectId ? `?subprojectId=${subprojectId}` : ''}`}
                    type={'qr'}
                    downloadText={'Last ned QR-koden'}
                    trackingProperties={trackingProperties}
                />
            );
        } else if (showPage === INSTAGRAM) {
            return (
                <InstagramShareInstructionsModalBlock
                    onBack={() => setShowPage(null)}
                    urlToShare={prettyUrlToShare}
                    projectId={project.id}
                    projectTitle={project.title}
                    subprojectId={subprojectId}
                    trackingProperties={trackingProperties}
                />
            );
        } else if (showPage === TVA_IMAGES) {
            return <TvaImagesModalContent onBack={() => setShowPage(null)} trackingProperties={trackingProperties} />;
        } else {
            return (
                <MobileStartModalContainer
                    setShowPage={setShowPage}
                    prettyUrlToShare={prettyUrlToShare}
                    trackingProperties={trackingProperties}
                    subprojectId={subprojectId}
                />
            );
        }
    };

    return (
        <Modal ref={modalRef} onClose={() => setShowPage(null)} ariaLabelledby="share-modal-title">
            {renderContent()}
        </Modal>
    );
};
